// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // <-- Import Firestore
import { getAuth } from "firebase/auth";       // <-- Import Auth

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB83v6kK_DcQXaF-zYx8ACqrck3lyT4yoo",
  authDomain: "electronics-store-app-1.firebaseapp.com",
  projectId: "electronics-store-app-1",
  storageBucket: "electronics-store-app-1.appspot.com", // Corrected this common typo, firebase adds .appspot.com
  messagingSenderId: "520920230054",
  appId: "1:520920230054:web:1c6db1863dd2fb9f392c67",
  measurementId: "G-4XCKJ1433Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export the services we need
export const db = getFirestore(app);       // <-- Initialize and export db
export const auth = getAuth(app);        // <-- Initialize and export auth